import './style.scss';

export function treatments_cta_block() {
    const block = document.querySelector('.treatments_cta_block');
    if (!block) return;
}

